'use strict'

import master from 'Modules/master'
import rollingTexts from 'Modules/rollingTexts'

master.process()
rollingTexts.initFooter()

var debounce = function (originalFn, delay = 150) {
    var timeout = null
    // return a new function that's throttled
    return function (...args) {
        // if currently in the timeout, return
        if (timeout) return
        timeout = setTimeout(() => (timeout = null), delay)
        originalFn(...args)
    }
}

var listener = function () {
    var list = document.getElementsByClassName('scroll-zone')
    for (let item of list) {
        var bounds = item.getBoundingClientRect()
        if (bounds.top > -40 && bounds.top < window.innerHeight) {
            var divs = document.getElementsByClassName('faq-title-active')
            for (let div of divs) {
                div.classList.remove('faq-title-active')
            }
            var data = document.getElementById('faq-title-' + item.dataset.id)
            data.classList.add('faq-title-active')
            break
        }
    }
}

window.addEventListener('scroll', debounce(listener))
if (document.getElementById('faqmodz') !== null) {
    document
        .getElementById('faqmodz')
        .addEventListener('scroll', debounce(listener))
}

let libelles = document.querySelectorAll('.libelle-faq')

libelles.forEach((elem) => {
    elem.addEventListener('click', function () {
        let id = this.getAttribute('data')

        if (this.classList.contains('libelle-faq--mob')) {
            window.location.href = '#' + id
        } else {
            let container = document.getElementById('faqmodz')
            let scrollTo = document.getElementById(id)
            container.scrollTop = scrollTo.offsetTop - 180
        }
    })
})

function fadeIn(element, duration = 600) {
    element.style.display = ''
    element.style.opacity = 0
    var last = +new Date()
    var tick = function () {
        element.style.opacity =
            +element.style.opacity + (new Date() - last) / duration
        last = +new Date()
        if (+element.style.opacity < 1) {
            ;(window.requestAnimationFrame && requestAnimationFrame(tick)) ||
                setTimeout(tick, 16)
        }
    }
    tick()
}

document.addEventListener('DOMContentLoaded', function () {
    let faqmodz = document.querySelector('#faqmodz')
    let button = document.querySelector('#scrollToTop')

    faqmodz.addEventListener('scroll', function (event) {
        if (
            faqmodz.scrollTop > 440 &&
            !button.classList.contains('force-visible')
        ) {
            button.classList.add('force-visible')
            fadeIn(button, 700)
            setTimeout(function () {
                button.classList.add('force-visible--heavy')
            }, 700)
        }
    })

    window.addEventListener('click', function (event) {
        if (event.target.classList.contains('j_go_top_pagination')) {
            faqmodz.scrollTop = 0
        }
    })
})
